export default {
  getPan(store) {
    return store.event.pan;
  },
  getSwipe(store) {
    return store.event.swipe;
  },
  toggleLeftMenu(store) {
    return store.menuLeft;
  },
  toggleMenu(store) {
    return store.menu;
  },
  toggleRightMenu(store) {
    return store.menuRight;
  },
};



// WEBPACK FOOTER //
// ./src/store/temp/temp.getters.js